import { render, staticRenderFns } from "./MixingplantCrud.vue?vue&type=template&id=580ab933"
import script from "./MixingplantCrud.vue?vue&type=script&lang=js"
export * from "./MixingplantCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports